import React from "react";

import { withAuthorizationModal } from "b2c/components/LoginButton";

export default withAuthorizationModal(({ children, ...rest }) => <div {...rest}>{children}</div>);
